import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'video-overflow',
    props: {
        image: { type: String, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const showVideo = ref(false);
        const props = __props;
        const __returned__ = { showVideo, props };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
